import React, { Component } from "react"
import { Router, Route, Switch } from "react-router-dom"
import { Provider } from "mobx-react"
import stores from "./stores"
import { ToastContainer } from "react-toastify"
import "./App.scss"
import "react-toastify/dist/ReactToastify.css"
import LoadingComponent from "./components/Loading"
import { syncHistoryWithStore } from "mobx-react-router"
import { createBrowserHistory } from "history"
import Loading from "./utilities/loading"
import LoadingBar from "./components/LoadingBar/LoadingBar"
import loadable from "@loadable/component"

const browserHistory = createBrowserHistory()
const history = syncHistoryWithStore(browserHistory, stores.router)

const fallback = <LoadingComponent />
const DefaultLayout = loadable(() => import("./containers/DefaultLayout"), { fallback })
const Login = loadable(() => import("./pages/Login/Login"), { fallback })
const Register = loadable(() => import("./pages/Register/Register"), { fallback })
const Page404 = loadable(() => import("./pages/Page404/Page404"), { fallback })
const Page500 = loadable(() => import("./pages/Page500/Page500"), { fallback })

class App extends Component {
  render() {
    return (
      <Provider {...stores}>
        <Router history={history}>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route path="/" name="Admin" component={DefaultLayout} />
          </Switch>
          <LoadingBar ref={(ref) => Loading.setComponent(ref)} />
          <ToastContainer />
        </Router>
      </Provider>
    )
  }
}

export default App
